<div *ngIf="visible" class="modal-overlay" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="settings-header">
      <h5>Dashboard Settings</h5>
      <button mat-icon-button type="button" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="isLoading" class="settings-loading">
      <mat-spinner diameter="48"></mat-spinner>
      <span class="settings-loading-text">Loading...</span>
    </div>

    <div [hidden]="isLoading">
    <div class="dashboard-picker-row">
      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="dashboard-picker-field">
        <mat-label>Dashboard</mat-label>
        <mat-select [ngModel]="editingDashboard.id" [disabled]="selectDisabled" (selectionChange)="loadDashboardIntoForm($event.value)">
          <mat-option value="" disabled>Select a dashboard</mat-option>
          <mat-option *ngFor="let db of dashboards" [value]="db.Id">{{ db.Name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button type="button" *ngIf="editingDashboard.id"
              (click)="startNewDashboard()" matTooltip="New Dashboard">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <hr class="settings-divider" />

    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="settings-name-field">
      <mat-label>Dashboard name</mat-label>
      <input matInput type="text" required [(ngModel)]="editingDashboard.name" />
      <mat-hint *ngIf="!editingDashboard.name?.trim()" class="name-required-hint">Name is required</mat-hint>
    </mat-form-field>

    <div class="default-toggle">
      <mat-slide-toggle color="accent"
        [checked]="editingDashboard.isDefault"
        (change)="editingDashboard.isDefault = !editingDashboard.isDefault">
        Set as new default
      </mat-slide-toggle>
    </div>

    <div class="settings-tabs">
      <span class="settings-tab" [class.active]="activeTab === 'select'" (click)="activeTab = 'select'">
        Select Cards
      </span>
      <span class="settings-tab" [class.active]="activeTab === 'order'" (click)="activeTab = 'order'">
        Card Order
      </span>
    </div>

    <div class="select-cards-panel" [hidden]="activeTab !== 'select'">
      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="settings-select-field" id="settingsStatusContainer">
        <mat-label>Status</mat-label>
        <mat-select multiple
          [(ngModel)]="statusSelected"
          (ngModelChange)="onMultiSelectChange('Status', $event, statusMultiSelect)">
          <mat-select-trigger>{{ displaySelected(statusSelected) }}</mat-select-trigger>
          <mat-option *ngFor="let opt of statusSelectOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="settings-select-field" id="settingsTagsContainer">
        <mat-label>Tags</mat-label>
        <mat-select multiple
          [(ngModel)]="tagSelected"
          (ngModelChange)="onMultiSelectChange('Tag', $event, tagsMultiSelect)">
          <mat-select-trigger>{{ displaySelected(tagSelected) }}</mat-select-trigger>
          <mat-option *ngFor="let opt of tagSelectOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="settings-select-field" id="settingsRestrictionsContainer">
        <mat-label>Restrictions</mat-label>
        <mat-select multiple
          [(ngModel)]="restrictionSelected"
          (ngModelChange)="onMultiSelectChange('Restriction', $event, restrictionsMultiSelect)">
          <mat-select-trigger>{{ displaySelected(restrictionSelected) }}</mat-select-trigger>
          <mat-option *ngFor="let opt of restrictionSelectOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="settings-select-field" id="settingsOthersContainer">
        <mat-label>Others</mat-label>
        <mat-select multiple
          [(ngModel)]="othersSelected"
          (ngModelChange)="onMultiSelectChange('Others', $event, othersMultiSelect)">
          <mat-select-trigger>{{ displaySelected(othersSelected) }}</mat-select-trigger>
          <mat-option *ngFor="let opt of othersSelectOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="order-panel" [hidden]="activeTab !== 'order'">
      <div class="order-hint">Drag to reorder cards</div>

      <div *ngIf="selectedCards.length === 0" class="order-empty">
        No cards selected
      </div>

      <div *ngFor="let card of selectedCards; let i = index"
           class="card-list-item"
           [class.drag-over]="dragOverIndex === i"
           [class.dragging]="dragIndex === i"
           draggable="true"
           (dragstart)="onDragStart(i)"
           (dragover)="onDragOver($event, i)"
           (drop)="onDrop(i)"
           (dragend)="onDragEnd()">
        <span class="card-list-label">
          <mat-icon class="drag-icon">drag_indicator</mat-icon>
          <span class="card-list-index">{{ i + 1 }}.</span>
          {{ cardLabel(card) }}
        </span>
        <button mat-icon-button type="button" (click)="removeCard(i)" aria-label="Remove card">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="settings-actions">
      <mat-spinner *ngIf="isSaving" diameter="24"></mat-spinner>
      <button mat-raised-button type="button" class="settings-btn settings-delete-btn"
              *ngIf="editingDashboard.id"
              [disabled]="isSaving"
              (click)="deleteDashboard()">Delete</button>
      <button mat-raised-button type="button" class="settings-btn settings-save-btn"
              [disabled]="!editingDashboard.name?.trim() || selectedCards.length === 0 || isSaving"
              (click)="saveDashboard()">{{ editingDashboard.id ? 'Save' : 'Add Dashboard' }}</button>
    </div>
    </div>
  </div>
</div>
